export interface SynchroStoreState {
  currentRepeat: number | undefined;
}

export const state = (): SynchroStoreState => ({
  currentRepeat: 'null' as unknown as number,
});
